import { defineComponent as n, openBlock as o, createBlock as a, unref as l, mergeProps as p, withCtx as d, createElementVNode as A } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const c = /* @__PURE__ */ n({
  name: "IconSpreadsheetInSquareFilled",
  __name: "IconSpreadsheetInSquareFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(r) {
    const t = r;
    return (m, e) => (o(), a(l(i), p(t, { "view-box": "0 0 24 24" }), {
      default: d(() => [...e[0] || (e[0] = [
        A("path", {
          "fill-rule": "evenodd",
          d: "M18 3.25A2.75 2.75 0 0 1 20.75 6v12A2.75 2.75 0 0 1 18 20.75H6A2.75 2.75 0 0 1 3.25 18V6A2.75 2.75 0 0 1 6 3.25h12M7 12a.5.5 0 0 0-.5.5v3A.5.5 0 0 0 7 16h1.5A.5.5 0 0 0 9 15.5v-3A.5.5 0 0 0 8.5 12H7m4 0a.5.5 0 0 0-.5.5v3A.5.5 0 0 0 11 16h6a.5.5 0 0 0 .5-.5v-3A.5.5 0 0 0 17 12h-6M7 8a.5.5 0 0 0-.5.5V10A.5.5 0 0 0 7 10.5h1.5A.5.5 0 0 0 9 10V8.5A.5.5 0 0 0 8.5 8H7m4 0a.5.5 0 0 0-.5.5V10a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V8.5A.5.5 0 0 0 17 8h-6",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  c as default
};
